export const store = {
  state: {
    drawer: false,
    email: localStorage.getItem("dfs_user"),
    role: localStorage.getItem("dfs_role"),
    token: localStorage.getItem("dfs_token"),
    useType: localStorage.getItem('dfs_use_type') ? localStorage.getItem('dfs_use_type') : 'all',
    plantListViewMode: localStorage.getItem('dfs_plant_list_view_mode') ? localStorage.getItem('dfs_plant_list_view_mode') : 'list',
    plant_search_filter: {
      useType: 'all',
      type: 'all',
      plant_name: '',
      plant_address: '',
      page: 1
    },
    pfs_search_filter: {
      ministry_id: '',
      plant_address: '',
      page: 1,
      checkUnknownPlant: 'clear_powplant',
    },
    infoDialog: {
      type: '',
      active: false,
      title: 'メッセージ',
      content: '',
      onClose: null,
    },
    confirmDialog: {
      active: false,
      title: '',
      content: '',
      onAgree: null,
      onDisagree: null,
    },
    mapview: {
      mode: null, // ２D・３D
      colorType: null, // サーモ・可視
      validColorTypes: [],
      plant: {},
      block: {},
      folder: {},
      folderId: null,
      breadcrumbs: [],
      changeColorType: null,
    },
    h2pmapview: {
      breadcrumbs: [],
    },
    openDialog: false,
    loading: false,
    currentReportStatus: null
  },
  updateLoginStatus(email, role, token) {
    this.state.email = email;
    this.state.role = role;
    this.state.token = token;
    localStorage.setItem("dfs_user", email);
    localStorage.setItem("dfs_role", role);
    localStorage.setItem("dfs_token", token);
  },
  updateLogoutStatus() {
    this.state.email = null;
    this.state.role = null;
    this.state.token = null;
    localStorage.removeItem("dfs_user");
    localStorage.removeItem("dfs_role");
    localStorage.removeItem("dfs_token");
  },
  updateUseType(useType) {
    this.state.useType = useType;
    localStorage.setItem('dfs_use_type', useType);
  },
  updatePlantListViewMode(mode){
    this.state.plantListViewMode = mode;
    localStorage.setItem("dfs_plant_list_view_mode", mode);
  },
  showInfoDialog(infoDialog) {
    this.state.infoDialog.active = true;
    this.state.infoDialog.type = infoDialog.type;
    this.state.infoDialog.content = infoDialog.content;
    this.state.infoDialog.onClose = infoDialog.onClose;
  },
  closeInfoDialog() {
    this.state.infoDialog.active = false;
    if (this.state.infoDialog.onClose) {
      this.state.infoDialog.onClose();
    }
    this.resetInfoDialog();
  },
  showSuccessDialog(message, onClose = null) {
    let infoDialog;
    infoDialog = {
      type: 'success',
      content: message,
      onClose: onClose,
    };
    this.showInfoDialog(infoDialog);
  },
  showErrorDialog(message, onClose = null) {
    let infoDialog;
    infoDialog = {
      type: 'error',
      content: message,
      onClose: onClose,
    };
    this.showInfoDialog(infoDialog);
  },
  showConfirmDialog(confirmDialog) {
    this.state.confirmDialog.active = true;
    this.state.confirmDialog.title = confirmDialog.title;
    this.state.confirmDialog.content = confirmDialog.content;
    this.state.confirmDialog.onAgree = confirmDialog.onAgree;
    this.state.confirmDialog.onDisagree = confirmDialog.onDisagree;
  },
  agreeConfirmDialog() {
    this.state.confirmDialog.active = false;
    if (this.state.confirmDialog.onAgree) {
      this.state.confirmDialog.onAgree();
    }
    this.resetConfirmDialog();
  },
  disagreeConfirmDialog() {
    this.state.confirmDialog.active = false;
    if (this.state.confirmDialog.onDisagree) {
      this.state.confirmDialog.onDisagree();
    }
    this.resetConfirmDialog();
  },
  resetInfoDialog() {
    this.state.infoDialog.active = false;
    this.state.infoDialog.type = '';
    this.state.infoDialog.content = '';
    this.state.infoDialog.onClose = null;
  },
  resetConfirmDialog() {
    this.state.confirmDialog.active = false;
    this.state.confirmDialog.title = '';
    this.state.confirmDialog.content = '';
    this.state.confirmDialog.onAgree = null;
    this.state.confirmDialog.onDisagree = null;
  },
  updateMapViewMode(mode) {
    this.state.mapview.mode = mode;
  },
  updateMapViewColorType(type) {
    this.state.mapview.colorType = type;
  },
  updateMapViewValidColorTypes(types) {
    this.state.mapview.validColorTypes = types;
  },
  setChangeMapviewColorType(handleFunction) {
    this.state.mapview.changeColorType = handleFunction;
  },
  changeMapViewColorType(type) {
    this.state.mapview.changeColorType(type);
  },
  updateMapViewFolderId(folderId) {
    this.state.mapview.folderId = folderId;
  },
  updateMapViewWholeInfo(data) {
    this.state.mapview.plant = data.plant;
    this.state.mapview.block = data.block;
    this.state.mapview.folder = data.folder;
  },
  updateMapViewFolder(folder){
    this.state.mapview.folder = folder;
  },
  updateMapViewBreadcrumbs(breadcrumbs) {
    this.state.mapview.breadcrumbs = breadcrumbs;
  },
  updateH2pMapViewBreadcrumbs(breadcrumbs) {
    this.state.h2pmapview.breadcrumbs = breadcrumbs;
  },
  updatePlantSearchFilter(filter) {
    this.state.plant_search_filter.useType = filter.use_type;
    this.state.plant_search_filter.type = filter.type;
    this.state.plant_search_filter.plant_name = filter.plant_name;
    this.state.plant_search_filter.plant_address = filter.plant_address;
    this.state.plant_search_filter.page = filter.page;
  },
  updatePfsSearchFilter(filter) {
    this.state.pfs_search_filter.ministry_id = filter.ministry_id;
    this.state.pfs_search_filter.plant_address = filter.plant_address;
    this.state.pfs_search_filter.page = filter.page;
    this.state.pfs_search_filter.checkUnknownPlant = filter.checkUnknownPlant;
  },
  updateOpenDialog(openDialog){
    this.state.openDialog = openDialog;
  },
  updateFilter(filter, folderId){
    this.state.filter = filter;
    localStorage.setItem('filter_' + folderId, JSON.stringify(filter));
  },
  getFilter(folderId){
    return localStorage.getItem('filter_' + folderId) ? JSON.parse(localStorage.getItem('filter_' + folderId)) : {
      "apply_for_ap": true,
      "apply_for_manual": true,
      "apply_for_ai": true,
      "panel_error_types": ["undefined","cell","multicell","cluster","module","string","junction","pid","shadow"],
      "airprobe_severities": [],
      "panel_error_reasons": ["undefined","crack","sediment","vegetation"],
      "airprobe_error_types": []
    };
  },
  getFilterFirstLoad(folderId){
    return !localStorage.getItem('filter_' + folderId);
  },
  showLoadingOverlay(status){
    this.state.loading = status;
  },
  updateFilterWhenAddOrUpdateAnnotation(folderId, annotation){
    const filter = localStorage.getItem('filter_' + folderId) ? JSON.parse(localStorage.getItem('filter_' + folderId)) : {
      "apply_for_ap": true,
      "apply_for_manual": true,
      "apply_for_ai": true,
      "panel_error_types": ["undefined","cell","multicell","cluster","module","string","junction","pid","shadow"],
      "airprobe_severities": [],
      "panel_error_reasons": ["undefined","crack","sediment","vegetation"],
      "airprobe_error_types": []
    };
    const panel_error_type_filter = filter.panel_error_types;
    const panel_reason_filter = filter.panel_error_reasons;
    if (annotation.type){
      if (!(annotation.type in panel_error_type_filter)){
        panel_error_type_filter.push(annotation.type)
      }
    }
    else {
      if (!('undefined' in panel_error_type_filter)){
        panel_error_type_filter.push('undefined')
      }
    }
    if (annotation.reason){
      if (!(annotation.reason in panel_reason_filter)){
        panel_reason_filter.push(annotation.reason)
      }
    }
    else {
      if (!('undefined' in panel_reason_filter)){
        panel_reason_filter.push('undefined')
      }
    }
    filter.panel_error_types = panel_error_type_filter;
    filter.panel_error_reasons = panel_reason_filter;
    this.updateFilter(filter, folderId);
  },
  updateCurrentReportStatus(currentReportStatus){
    this.state.currentReportStatus = currentReportStatus;
  },
  updateMenuDrawer(drawerStatus) {
    this.state.drawer = drawerStatus;
  }
}
